export default __webpack_public_path__ + "static/media/com-bm.7dff4266.mp4";